document.querySelectorAll('.Index_object_team_details_media_slider').forEach(function (Index_object_team_details_media_slider) {
    new Swiper(Index_object_team_details_media_slider, {
        loop: false,
        grabCursor: false,
        spaceBetween: 16,
        slidesPerGroup: 1,
        slidesPerView: 4,
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        freeMode: !0,
        breakpoints: {
            0: {
                freeMode: !1,
                spaceBetween: 10,
                slidesPerView: "auto"
            },
            750: {
                spaceBetween: 16,
                slidesPerView: 4
            },
            990: {
            },
            1200: {
            },
            1440: {
            }
        }
    })
})

let swiperInstance = null;

function initSwiper() {
    const isDesktop = window.matchMedia("(min-width: 750px)").matches;
    const Team_slider = document.querySelector('.Team_slider');

    if (Team_slider && isDesktop && !swiperInstance) {
        swiperInstance = new Swiper('.Team_slider', {
            loop: false,
            grabCursor: true,
            spaceBetween: 16,
            slidesPerGroup: 1,
            slidesPerView: "auto",
            watchSlidesProgress: true,
            draggable: true,
            autoHeight: false,
            watchOverflow: true,
            threshold: 10,
            mousewheel: {
                forceToAxis: true
            },
            observer: true,
            observeParents: true,
            freeMode: true
        });
    } else if (!isDesktop && swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
    }
}

// Run on load
initSwiper();

// Run on resize
window.addEventListener("resize", debounce(initSwiper, 150));

/* Team Drawer */
document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.team_drawer_open');
  if (!trigger) return;

  const popupClass = trigger.getAttribute('popup_id');
  if (!popupClass) return;

  // close any open popup first (optional but recommended)
  document.querySelectorAll('.Team_innerloop_maindrawer_new.open').forEach(el => el.classList.remove('open'));

  const target = document.querySelector(`.Team_innerloop_maindrawer_new.${popupClass}`);
  if (!target) return;

  trigger.classList.add('active');
  target.classList.add('open');
  document.body.classList.add('team_drawer_is_open');
});

document.addEventListener('click', function (e) {
  const closeTrigger = e.target.closest('.team_drawer_overlay_new, .team_drawer_close');
  if (!closeTrigger) return;

  document.body.classList.remove('team_drawer_is_open');

  document.querySelectorAll('.team_drawer_open').forEach(el => el.classList.remove('active'));
  document.querySelectorAll('.Team_innerloop_maindrawer_new.open').forEach(el => el.classList.remove('open'));
});
/* Team Drawer */

document.querySelector(".team_more_mobile_button_new").addEventListener("click", function () {
    document.querySelectorAll(".show_more_mobile_new").forEach(el => el.classList.add('show'));
    document.querySelector(".team_more_mobile_button_new").classList.add("hide");
});